export const courses = {
  title: "Cursos",
  subtitle: "Formación especializada para educadores, madres y padres",
  accompaniment: {
    title: "Curso acompañamiento:",
    subtitle: "Acompañar a niñas y niños (2025-2026)",
    description: "Herramientas personales para la/el acompañante. El placer de aprender por descubrimiento.\n\nCurso de formación dirigido a educadores/as, madres y padres en el que utilizaremos una metodología participativa, con momentos para reflexionar y compartir, dedicando mucho tiempo a vivenciar y practicar las habilidades relacionadas con cada tema.",
    trainers: {
      title: "Formadores",
      names: "Tinus Wijnakker y Beatriz Aguilera Reija, fundadores de la escuela Alavida en Madrid con 25 años de experiencia."
    },
    duration: {
      title: "Duración",
      block1: "1º bloque: 24 horas",
      block2: "2º bloque: 24 horas", 
      block3: "3º bloque: 36 horas"
    },
    dates: {
      title: "Fechas",
      block1: "1º bloque",
      block1Dates: "7-8 de noviembre / 28-29 de noviembre",
      block2: "2º bloque", 
      block2Dates: "23-24 de enero / 20-21 de febrero",
      block3: "3º bloque",
      block3Dates: "27-28 de marzo/ 24-25 de abril /22-23 de mayo"
    },
    schedule: {
      title: "Horario",
      friday: "Viernes",
      fridayTime: "de 17:30 a 21:30 h.",
      saturday: "Sábados", 
      saturdayTime: "de 9:00 a 13:30 h. y de 15.00 a 18.30 h."
    },
    location: {
      title: "Lugar",
      place: "Gándara International School"
    },
    capacity: {
      title: "Aforo máximo",
      block1: "Primer bloque: máximo de aforo: 25 personas",
      blocks23: "Segundo y Tercer bloque: máximo de aforo: 30 personas. (Se pueden apuntar también participantes de cursos anteriores)."
    },
    prices: {
      title: "Precios",
      fullEarly: "Curso entero (pagando antes del 10 de octubre): 500 €",
      fullBlocks: "Curso entero (pagando en tres bloques): 160€ + 160€ + 240€ = 560€",
      block12: "Bloque 1 o 2 por separado: 170 €",
      block3: "Bloque 3: 240€",
      note1: "Para participar únicamente en el bloque 3 será necesario haber hecho previamente alguna formación con Tinus Wijnakker.",
      note2: "Las personas que se apuntan a todo el curso tienen preferencia."
    },
    content: {
      title: "CONTENIDOS DEL CURSO:",
      blocks12: {
        title: "1º y 2º bloque: Herramientas personales para la/el acompañante",
        instructor: "A cargo de Tinus Wijnakker",
        block1: {
          title: "Bloque 1 - 1º fin de semana (7-8 de noviembre)",
          topic: "La observación y procesos de comunicación:",
          point1: "¿Cómo observamos? y ¿Cómo nos afecta nuestra manera de observar?",
          point2: "La importancia de ver y entender las señales de comunicación.",
          point3: "La comunicación no-verbal y la verbal",
          point4: "¿Cómo interpretar los mensajes de niñas y niños?"
        },
        weekend2: {
          title: "2º fin de semana (28-29 de noviembre)",
          topic: "La escucha activa:",
          point1: "Escuchar para entender y acompañar.",
          point2: "El lenguaje de la aceptación: Reflejar y acompañar.",
          point3: "La comunicación no-verbal y el contacto físico"
        }
      },
      block2: {
        title: "Bloque 2",
        weekend3: {
          title: "3º fin de semana (23-24 de enero)",
          topic1: "Amor y seguridad:",
          point1: "Necesidades básicas.",
          point2: "¿Cómo alguien se siente amado/a y seguro/a?.",
          point3: "Apoyo emocional.",
          point4: "Escuchar, aceptar y acompañar sentimientos.",
          topic2: "Libertad, límites y autonomía:",
          point5: "Un ambiente relajado.",
          point6: "Límites, normas de convivencia y castigos.",
          point7: "Libertad y autonomía."
        },
        weekend4: {
          title: "4º fin de semana (20-21 de febrero)",
          topic: "Situaciones conflictivas:",
          point1: "Conflictos, agresividad y violencia.",
          point2: "Analizar una situación conflictiva.",
          point3: "Acompañar para facilitar el proceso de la regulación."
        }
      },
      block3: {
        title: "Bloque 3: El placer de aprender por descubrimiento.",
        instructors: "A cargo de Beatriz Aguilera y Tinus Wijnakker",
        weekend5: {
          title: "5º fin de semana (27-28 de marzo)",
          topic1: "Etapas evolutivas:",
          point1: "Infancia: de 0 a 6 años: etapa sensorio-motriz-afectiva",
          point2: "Niñez: de 6 a 12 años: etapa de las operaciones concretas",
          topic2: "Ambientes preparados:",
          point3: "Los rincones.",
          point4: "Las estructuras."
        },
        weekend6: {
          title: "6º fin de semana (24-25 de abril)",
          topic1: "El rol del adulto:",
          point1: "El vínculo y el apoyo emocional",
          point2: "Guía y referencia.",
          topic2: "La convivencia:",
          point3: "El proceso de relaciones personales y grupales.",
          point4: "Responsabilidades y autonomía.",
          point5: "Límites, normas de convivencia y consecuencias.",
          point6: "Las situaciones de conflictos."
        },
        weekend7: {
          title: "7º fin de semana (22-23 de mayo)",
          topic: "El proceso de aprendizaje:",
          point1: "¿Cómo aprenden las niñas y los niños?.",
          point2: "Factores sociales y emocionales.",
          point3: "La curiosidad y el interés como motores de aprendizaje",
          point4: "Aprendizaje autónomo",
          point5: "Presentaciones",
          point6: "El aprendizaje por descubrimiento"
        }
      }
    }
  },
  psychomotricity: {
    title: "CURSO PSICOMOTRICIDADE EDUCATIVA",
    subtitle: "\"Psicomotricidade na educación infantil e primer ciclo de primaria. Teoría e recursos para ao aula\"",
    dateTime: {
      title: "Fecha y Horario",
      details: "25 de outubro de 10:00 a 17.00 en Gándara School en Gondomar."
    },
    price: {
      title: "Precio",
      amount: "60€/persona"
    },
    lunchNote: "Haberá unha pausa para comer, recomendamos traer tupper coa comida e disfrutar do espazo e da compañía neste ratiño de descanso.",
    content: {
      title: "Contenido del curso:",
      point1: "Traballo de sensibilización corporal",
      point2: "Iniciación á teoría da psicomotricidade relacional",
      point3: "Xogos e dinámicas corporais para traballar nos ciclos educativos 3-8 anos",
      point4: "Repasaremos os aspectos fundamentais da práctica psicomotriz",
      point5: "Adaptaremos as dinámicas según as necesidades educativas das persoas que acudan a formación para que teñades recursos para facer nas aulas",
      point6: "Levaredes textos de teoría e práctica para ampliar os coñecementos trala formación."
    }
  },
  contact: {
    title: "Más información e inscripciones",
    description: "Para más información y/o apuntarse:"
  }
};